import axios from "axios";

const endpoint_url = "/message/whatsappOtpReport/totalSpentReport";

const totalSpentReport = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url)
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default totalSpentReport;
